import { createSelector } from 'reselect';
import get from 'lodash/get';

export const getDisabledReportPagination = (state) => get(state, 'reports.disabled.pagination', {});

export const getDisabledReportFilters = (state) => get(state, 'reports.disabled.filters', {});

export const getDisabledReportNeedFetch = (state) =>
  get(state, 'reports.disabled.needFetch', false);

export const getDisabledReportIsLoading = (state) =>
  get(state, 'reports.disabled.isLoading', false);

export const getDisabledReportAssets = (state) =>
  get(state, 'reports.disabled.entities.assets', {});
export const getDisabledReportAssetsIds = (state) =>
  get(state, 'reports.disabled.result.assets', []);

export const getDisabledReportVisibleAssets = createSelector(
  [getDisabledReportAssetsIds, getDisabledReportAssets],
  (ids, assets) => ids.map((id) => assets[id])
);



// WEBPACK FOOTER //
// src/modules/secured/modules/reports/selectors/disabled_report_selectors.js